import React, { CSSProperties, MouseEventHandler, MouseEvent } from "react";

import * as styles from "./style.module.css";

type TButton = {
  disabled?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  style?: CSSProperties;
  text: string;
};

const Button = ({ disabled, onClick, style, text }: TButton) => {

  const hanleClick = (event: React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    onClick && onClick(event);
  }
  return (
    <button
      className={styles.btn}
      onClick={hanleClick}
      style={style}
      type="button"
      disabled={disabled}
    >
      {text}
    </button>
)};

export default Button;
